<template>
  <div class="geoip-option" :class="{ 'geoip-option--wide': image?.src }">
    <button
      class="geoip-option__close-btn"
      aria-label="Close button"
      data-refapp-tagging-target="continue"
      @click="closeModal"
    ></button>
    <div v-if="image?.src" class="geoip-option__img-container">
      <img :src="image?.src" :alt="image?.alt" width="400" height="400" />
    </div>
    <div class="geoip-option__content-container">
      <h2>{{ title }}</h2>
      <p class="geoip-option__content-description">{{ description }}</p>
      <div class="geoip-option__group">
        <select
          id="geoip-countries-select"
          v-model="selectedCountryCode"
          class="geoip-option__countries-select"
          aria-label="Your preferred country"
        >
          <option v-for="(country, index) in countries" :key="index" :value="country.code">
            {{ country.name }}
          </option>
        </select>
        <div class="geoip-option__buttons">
          <button
            data-refapp-tagging-target="change-country"
            :data-refapp-tagging-extras="
              JSON.stringify({ eventLabel: selectedCountry?.name.toLowerCase() })
            "
            :style="{ backgroundColor: btnBgColor, color: btnTextColor }"
            @click="redirect"
          >
            {{ redirectLabel }}
          </button>
          <button
            data-refapp-tagging-target="continue"
            :style="{ backgroundColor: btnBgColor, color: btnTextColor }"
            @click="closeModal"
          >
            {{ continueLabel }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { geoipProps } from './props-definitions';
export default {
  name: 'refapp-geoip-option',
  props: geoipProps,
  data() {
    return {
      selectedCountryCode: this.findCountryByCode(this.defaultCountryCode)
        ? this.defaultCountryCode
        : this.countries[0].code,
    };
  },
  computed: {
    selectedCountry() {
      return this.findCountryByCode(this.selectedCountryCode);
    },
  },
  methods: {
    findCountryByCode(code) {
      return this.countries.find((country) => country.code === code);
    },
    closeModal() {
      this.setCookie();
      this.$emit('close-modal');
    },
    redirect() {
      const url = this.selectedCountry.url;
      this.setCookie();
      window.location.href = url;
    },
    setCookie() {
      this.$cookies.set('geoip-redirect', true, this.cookieExpiration);
    },
  },
};
</script>
